import { Button } from '@thg-commerce/gravity-elements'
import { Grid, GridItem } from '@thg-commerce/gravity-system'
import { spacing, styled, Text, TextStyling } from '@thg-commerce/gravity-theme'

import { marginRightDesktop } from '../../ProductReviewContent/styles'

export const MainWrapper = styled.div`
  padding-top: ${spacing(3)};
  margin: ${spacing(10)} 0;
  border-top: solid 1px ${(props) => props.theme.colors.palette.greys.light};
`

export const ReviewsGrid = styled(Grid)`
  margin: 0;
`

export const ReviewTitle = styled.h3<{
  textAlignment?: string | undefined
  textStyle?: TextStyling
  textTransform?: string | undefined
}>`
  ${(props) =>
    Text(
      props.textStyle?.entry ?? 'large2',
      props.textStyle?.style ?? 'alternate',
    )};
  text-transform: ${(props) => props.textTransform || 'uppercase'};
  padding-bottom: ${spacing(2)};
  ${(props) => props.textAlignment && `text-align: ${props.textAlignment}`};
`

export const NoReviewTitle = styled.h3<{
  textStyle?: TextStyling
}>`
  ${(props) =>
    Text(
      props.textStyle?.entry ?? 'large2',
      props.textStyle?.style ?? 'alternate',
    )};
  margin-top: ${spacing(2)};
`

export const TopReviewsTitle = styled.h3<{
  textStyle?: TextStyling
  showInlineFeatureScores?: boolean
}>`
  ${(props) =>
    Text(
      props.textStyle?.entry ?? 'large2',
      props.textStyle?.style ?? 'alternate',
    )};
  padding-bottom: ${spacing(1)};
`

export const ReviewOverview = styled(GridItem)`
  margin: 0;
`

export const DisclaimerText = styled.p`
  max-width: 530px;
  margin-bottom: ${spacing(4)};
`

export const IndividualReviews = styled(GridItem)`
  margin: 0;
`

export const IndividualReviewsGridItem = styled(GridItem)<{
  showInlineFeatureScores?: boolean
}>`
  ${marginRightDesktop}
`

export const NoReviewsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${spacing(2)};
  border: 1px solid ${(props) => props.theme.colors.palette.greys.light};
  border-radius: ${spacing(1)};
  margin-top: ${spacing(3)};
`

export const NoReviewsParagraph = styled.p`
  ${Text('bodyText', 'default')};
  max-width: 560px;
  text-align: center;
  margin-top: ${spacing(1)};
`

export const CreateReviewButton = styled(Button)`
  margin-top: ${spacing(3)};
  margin-bottom: ${spacing(3)};
  line-height: 48px;
`
